import { currencyFormatter } from '@/utils/number';
import { Popover } from 'antd';
import moment from 'moment';
import { CheckCircle } from 'react-feather';

export interface Props {
  conciliatedInstallment: {
    transactionName: string;
    transactionValue: number;
    transactionPayDate: string;
    conciliatedDate: string;
  };
}

export default function BankConciliationPopoverDetails(props: Props) {
  const conciliatedInstallment = props?.conciliatedInstallment;

  return (
    <Popover
      placement="right"
      title="Liquidada a partir de uma conciliação"
      content={
        <div style={{ maxWidth: 400 }}>
          <p>
            <strong>Nome da Transação: </strong>
            {conciliatedInstallment?.transactionName}
          </p>
          <p>
            <strong>Data da conciliação: </strong>
            {moment(conciliatedInstallment?.conciliatedDate).format(
              'DD/MM/YYYY',
            )}
          </p>
          <p>
            <strong>Data pagamento da transação: </strong>
            {moment(conciliatedInstallment?.transactionPayDate).format(
              'DD/MM/YYYY',
            )}
          </p>
          <p>
            <strong>Valor da transação: </strong>
            {currencyFormatter(conciliatedInstallment?.transactionValue)}
          </p>
        </div>
      }
    >
      <CheckCircle color="green" fill="#8CE99A" />
    </Popover>
  );
}
